import { TicketTimeLimitOverrideListItem } from '../../../integrated-client/models/';

export class ResultsData {
  items: TicketTimeLimitOverrideListItem[]
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }
}